"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ButtonIcon", {
    enumerable: true,
    get: function() {
        return ButtonIcon;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ButtonIcon = {
    baseStyle: function(_param) {
        var isRound = _param.isRound, theme = _param.theme, variant = _param.variant, props = _object_without_properties(_param, [
            "isRound",
            "theme",
            "variant"
        ]);
        var buttonStyles = theme.components.Button;
        var buttonVariant = buttonStyles.variants[variant];
        var resolvedButtonVariant = typeof buttonVariant === "function" ? buttonVariant(props) : buttonVariant;
        var buttonLoadingStyles = resolvedButtonVariant.loading;
        var borderRadius = isRound ? "full" : "radii-button";
        return {
            borderRadius: borderRadius,
            loading: buttonLoadingStyles,
            _before: _object_spread_props(_object_spread({}, buttonVariant._before), {
                borderRadius: borderRadius
            })
        };
    },
    sizes: {
        xs: {
            px: "spacer-button-icon-XS",
            py: "spacer-button-icon-XS",
            loading: {
                width: "0.75rem",
                height: "0.75rem",
                padding: 0
            }
        },
        s: {
            px: "spacer-button-icon-S",
            py: "spacer-button-icon-S",
            loading: {
                width: "0.75rem",
                height: "0.75rem",
                padding: 0
            }
        },
        m: {
            px: "spacer-button-icon-M",
            py: "spacer-button-icon-M",
            loading: {
                width: "1rem",
                height: "1rem",
                padding: 0
            }
        },
        l: {
            px: "spacer-button-icon-L",
            py: "spacer-button-icon-L",
            loading: {
                width: "1rem",
                height: "1rem",
                padding: 0
            }
        }
    },
    defaultProps: {
        size: "m",
        variant: "primary"
    }
};
